import { createContext } from 'react';

export type EditGroupCtx = {
  showEditGroupErrorAlert: boolean;
  editGroupError: string;
};

const EditGroupDialogueContext = createContext<EditGroupCtx>({
  showEditGroupErrorAlert: false,
  editGroupError: '',
});

export default EditGroupDialogueContext;